export default __webpack_public_path__ + "static/kadry-fdeecdbd74dff5fe2b52362b5aa35aa5.jpeg";